module.exports = __webpack_public_path__ + "static/media/icon_service_02_pc.56f166a5.webp";